import Vue from 'vue';
import service from './base.service'
import {AxiosPromise} from 'axios';
import {AppResponse} from '@/share/response';
import {RecentSearchDto, RecentSearchModel} from "@/share";

export class RecentSearchService extends Vue {
  private RESOURCE = 'front/recent-search';

  public list(): AxiosPromise<AppResponse<RecentSearchModel[]>> {
    return service.get<AppResponse<RecentSearchModel[]>>(this.RESOURCE);
  }

  public delete(id: string | number): AxiosPromise<AppResponse<any>> {
    return service.delete<AppResponse<any>>(`${this.RESOURCE}/${id}`);
  }

  public create(payload: RecentSearchDto): AxiosPromise<AppResponse<RecentSearchModel>> {
    return service.post<AppResponse<RecentSearchModel>>(this.RESOURCE, payload);
  }

  public update(id: string | number): AxiosPromise<AppResponse<RecentSearchModel>> {
    return service.put<AppResponse<RecentSearchModel>>(`${this.RESOURCE}/${id}`);
  }
}
